import CreateReleasePipeline from 'components/release-pipelines/CreateReleasePipeline'

export default function CreateReleasePipelinePage() {
  return <CreateReleasePipeline />
}
